import React from "react";
import { Link } from "react-router-dom";

function GenericButton(props) {
  const { href, text } = props;
  return (
    <Link to={href} className="genericBtn">
      <button
        style={{
          fontSize: "1.2rem",
          padding: "15px",
          color: "#fff",
          backgroundColor: "#ED1D90",
        }}
      >
        <h4>{text}</h4>
      </button>
    </Link>
  );
}

export default GenericButton;
